import * as s from "react";
import { useEffect as at } from "react";
import { useEventListener as L, useMountEffect as it, useUpdateEffect as F, useUnmountEffect as lt, PrimeReact as K, Portal as ot, localeOption as ut, Ripple as ce } from "./portal.esm.79076359.js";
import { CSSTransition as ct } from "./csstransition.esm.5346b5f2.js";
import { DomHandler as u, ZIndexUtils as U, jsx as g, UniqueComponentId as st, ObjectUtils as Y, classNames as M, jsxs as N } from "./utils.esm.ea524c19.js";
function G(e, c) {
  (c == null || c > e.length) && (c = e.length);
  for (var i = 0, v = new Array(c); i < c; i++)
    v[i] = e[i];
  return v;
}
function dt(e) {
  if (Array.isArray(e))
    return G(e);
}
function ft(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null)
    return Array.from(e);
}
function de(e, c) {
  if (!!e) {
    if (typeof e == "string")
      return G(e, c);
    var i = Object.prototype.toString.call(e).slice(8, -1);
    if (i === "Object" && e.constructor && (i = e.constructor.name), i === "Map" || i === "Set")
      return Array.from(e);
    if (i === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(i))
      return G(e, c);
  }
}
function mt() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function gt(e) {
  return dt(e) || ft(e) || de(e) || mt();
}
function vt(e) {
  if (Array.isArray(e))
    return e;
}
function bt(e, c) {
  var i = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (i != null) {
    var v = [], d = !0, z = !1, y, E;
    try {
      for (i = i.call(e); !(d = (y = i.next()).done) && (v.push(y.value), !(c && v.length === c)); d = !0)
        ;
    } catch (h) {
      z = !0, E = h;
    } finally {
      try {
        !d && i.return != null && i.return();
      } finally {
        if (z)
          throw E;
      }
    }
    return v;
  }
}
function yt() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function D(e, c) {
  return vt(e) || bt(e, c) || de(e, c) || yt();
}
var j = /* @__PURE__ */ s.forwardRef(function(e, c) {
  var i = s.useState(e.id), v = D(i, 2), d = v[0], z = v[1], y = s.useState(!1), E = D(y, 2), h = E[0], _ = E[1], P = s.useState(!1), Z = D(P, 2), J = Z[0], q = Z[1], fe = s.useState(e.maximized), W = D(fe, 2), Q = W[0], me = W[1], r = s.useRef(null), x = s.useRef(null), p = s.useRef(null), ee = s.useRef(null), te = s.useRef(null), V = s.useRef(null), I = s.useRef(!1), T = s.useRef(!1), R = s.useRef(null), k = s.useRef(null), O = s.useRef(null), A = s.useRef(""), C = e.onMaximize ? e.maximized : Q, ge = L({
    type: "keydown",
    listener: function(t) {
      return Ne(t);
    }
  }), ne = D(ge, 2), ve = ne[0], be = ne[1], ye = L({
    type: "mousemove",
    target: function() {
      return window.document;
    },
    listener: function(t) {
      return He(t);
    }
  }), re = D(ye, 2), he = re[0], Se = re[1], ze = L({
    type: "mouseup",
    target: function() {
      return window.document;
    },
    listener: function(t) {
      return $e(t);
    }
  }), ae = D(ze, 2), De = ae[0], Ee = ae[1], xe = L({
    type: "mousemove",
    target: function() {
      return window.document;
    },
    listener: function(t) {
      return Te(t);
    }
  }), ie = D(xe, 2), Re = ie[0], ke = ie[1], Ce = L({
    type: "mouseup",
    target: function() {
      return window.document;
    },
    listener: function(t) {
      return Oe(t);
    }
  }), le = D(Ce, 2), we = le[0], _e = le[1], B = function(t) {
    e.onHide(), t.preventDefault();
  }, Ie = function() {
    var t = document.activeElement, a = t && r.current && r.current.contains(t);
    !a && e.closable && e.showHeader && V.current.focus();
  }, Le = function(t) {
    e.dismissableMask && e.modal && x.current === t.target && B(t), e.onMaskClick && e.onMaskClick(t);
  }, Me = function(t) {
    e.onMaximize ? e.onMaximize({
      originalEvent: t,
      maximized: !C
    }) : me(function(a) {
      return !a;
    }), t.preventDefault();
  }, Ne = function(t) {
    var a = t.currentTarget;
    if (!(!a || !a.primeDialogParams)) {
      var l = a.primeDialogParams, m = l.length, S = l[m - 1] ? l[m - 1].id : void 0;
      if (S === d) {
        var b = document.getElementById(S);
        if (e.closable && e.closeOnEscape && t.key === "Escape")
          B(t), t.stopImmediatePropagation(), l.splice(m - 1, 1);
        else if (t.key === "Tab") {
          t.preventDefault();
          var o = u.getFocusableElements(b);
          if (o && o.length > 0)
            if (!document.activeElement)
              o[0].focus();
            else {
              var f = o.indexOf(document.activeElement);
              t.shiftKey ? f === -1 || f === 0 ? o[o.length - 1].focus() : o[f - 1].focus() : f === -1 || f === o.length - 1 ? o[0].focus() : o[f + 1].focus();
            }
        }
      }
    }
  }, Pe = function(t) {
    u.hasClass(t.target, "p-dialog-header-icon") || u.hasClass(t.target.parentElement, "p-dialog-header-icon") || e.draggable && (I.current = !0, R.current = t.pageX, k.current = t.pageY, r.current.style.margin = "0", u.addClass(document.body, "p-unselectable-text"), e.onDragStart && e.onDragStart(t));
  }, Te = function(t) {
    if (I.current) {
      var a = u.getOuterWidth(r.current), l = u.getOuterHeight(r.current), m = t.pageX - R.current, S = t.pageY - k.current, b = r.current.getBoundingClientRect(), o = b.left + m, f = b.top + S, w = u.getViewport();
      r.current.style.position = "fixed", e.keepInViewport ? (o >= e.minX && o + a < w.width && (R.current = t.pageX, r.current.style.left = o + "px"), f >= e.minY && f + l < w.height && (k.current = t.pageY, r.current.style.top = f + "px")) : (R.current = t.pageX, r.current.style.left = o + "px", k.current = t.pageY, r.current.style.top = f + "px"), e.onDrag && e.onDrag(t);
    }
  }, Oe = function(t) {
    I.current && (I.current = !1, u.removeClass(document.body, "p-unselectable-text"), e.onDragEnd && e.onDragEnd(t));
  }, Ae = function(t) {
    e.resizable && (T.current = !0, R.current = t.pageX, k.current = t.pageY, u.addClass(document.body, "p-unselectable-text"), e.onResizeStart && e.onResizeStart(t));
  }, oe = function(t, a, l) {
    !l && (l = u.getViewport());
    var m = parseInt(t);
    return /^(\d+|(\.\d+))(\.\d+)?%$/.test(t) ? m * (l[a] / 100) : m;
  }, He = function(t) {
    if (T.current) {
      var a = t.pageX - R.current, l = t.pageY - k.current, m = u.getOuterWidth(r.current), S = u.getOuterHeight(r.current), b = r.current.getBoundingClientRect(), o = u.getViewport(), f = !parseInt(r.current.style.top) || !parseInt(r.current.style.left), w = oe(r.current.style.minWidth, "width", o), H = oe(r.current.style.minHeight, "height", o), $ = m + a, X = S + l;
      f && ($ += a, X += l), (!w || $ > w) && b.left + $ < o.width && (r.current.style.width = $ + "px"), (!H || X > H) && b.top + X < o.height && (r.current.style.height = X + "px"), R.current = t.pageX, k.current = t.pageY, e.onResize && e.onResize(t);
    }
  }, $e = function(t) {
    T.current && (T.current = !1, u.removeClass(document.body, "p-unselectable-text"), e.onResizeEnd && e.onResizeEnd(t));
  }, Xe = function() {
    r.current.style.position = "", r.current.style.left = "", r.current.style.top = "", r.current.style.margin = "";
  }, Ye = function() {
    var t = ["center", "left", "right", "top", "top-left", "top-right", "bottom", "bottom-left", "bottom-right"], a = t.find(function(l) {
      return l === e.position || l.replace("-", "") === e.position;
    });
    return a ? "p-dialog-".concat(a) : "";
  }, je = function() {
    r.current.setAttribute(A.current, "");
  }, Ve = function() {
    e.onShow && e.onShow(), e.focusOnShow && Ie(), Ke();
  }, Be = function() {
    e.modal && u.addClass(x.current, "p-component-overlay-leave"), e.blockScroll && u.removeClass(document.body, "p-overflow-hidden");
  }, Fe = function() {
    I.current = !1, U.clear(x.current), _(!1), ue();
  }, Ke = function() {
    Ue(), (e.blockScroll || e.maximizable && C) && u.addClass(document.body, "p-overflow-hidden");
  }, ue = function() {
    Ge();
    var t = e.maximizable && C;
    if (e.modal) {
      var a = document.primeDialogParams && document.primeDialogParams.some(function(l) {
        return l.hasBlockScroll;
      });
      (a || t) && u.removeClass(document.body, "p-overflow-hidden");
    } else
      (e.blockScroll || t) && u.removeClass(document.body, "p-overflow-hidden");
  }, Ue = function() {
    e.draggable && (Re(), we()), e.resizable && (he(), De()), ve();
    var t = {
      id: d,
      hasBlockScroll: e.blockScroll
    };
    document.primeDialogParams = document.primeDialogParams ? [].concat(gt(document.primeDialogParams), [t]) : [t];
  }, Ge = function() {
    ke(), _e(), Se(), Ee(), be(), document.primeDialogParams = document.primeDialogParams && document.primeDialogParams.filter(function(t) {
      return t.id !== d;
    });
  }, Ze = function() {
    if (!O.current) {
      O.current = u.createInlineStyle(K.nonce);
      var t = "";
      for (var a in e.breakpoints)
        t += `
                    @media screen and (max-width: `.concat(a, `) {
                        .p-dialog[`).concat(A.current, `] {
                            width: `).concat(e.breakpoints[a], ` !important;
                        }
                    }
                `);
      O.current.innerHTML = t;
    }
  }, Je = function() {
    if (!e.blockScroll) {
      var t = C ? "addClass" : "removeClass";
      u[t](document.body, "p-overflow-hidden");
    }
  };
  it(function() {
    var n = st();
    d || z(n), A.current || (A.current = n), e.visible && _(!0), e.breakpoints && Ze();
  }), F(function() {
    e.visible && !h && _(!0), e.visible !== J && h && q(e.visible);
  }), F(function() {
    h && (U.set("modal", x.current, K.autoZIndex, e.baseZIndex || K.zIndex.modal), q(!0));
  }, [h]), F(function() {
    Je();
  }, [e.maximized, Q]), lt(function() {
    ue(), u.removeInlineStyle(O.current), U.clear(x.current);
  }), s.useImperativeHandle(c, function() {
    return {
      props: e,
      resetPosition: Xe,
      getElement: function() {
        return r.current;
      },
      getMask: function() {
        return x.current;
      },
      getContent: function() {
        return p.current;
      },
      getHeader: function() {
        return ee.current;
      },
      getFooter: function() {
        return te.current;
      },
      getCloseButton: function() {
        return V.current;
      }
    };
  });
  var qe = function() {
    if (e.closable) {
      var t = e.ariaCloseIconLabel || ut("close");
      return /* @__PURE__ */ N("button", {
        ref: V,
        type: "button",
        className: "p-dialog-header-icon p-dialog-header-close p-link",
        "aria-label": t,
        onClick: B,
        children: [/* @__PURE__ */ g("span", {
          className: "p-dialog-header-close-icon pi pi-times",
          "aria-hidden": "true"
        }), /* @__PURE__ */ g(ce, {})]
      });
    }
    return null;
  }, We = function() {
    var t = M("p-dialog-header-maximize-icon pi", {
      "pi-window-maximize": !C,
      "pi-window-minimize": C
    });
    return e.maximizable ? /* @__PURE__ */ N("button", {
      type: "button",
      className: "p-dialog-header-icon p-dialog-header-maximize p-link",
      onClick: Me,
      children: [/* @__PURE__ */ g("span", {
        className: t
      }), /* @__PURE__ */ g(ce, {})]
    }) : null;
  }, Qe = function() {
    if (e.showHeader) {
      var t = qe(), a = We(), l = Y.getJSXElement(e.icons, e), m = Y.getJSXElement(e.header, e), S = d + "_header", b = M("p-dialog-header", e.headerClassName);
      return /* @__PURE__ */ N("div", {
        ref: ee,
        style: e.headerStyle,
        className: b,
        onMouseDown: Pe,
        children: [/* @__PURE__ */ g("div", {
          id: S,
          className: "p-dialog-title",
          children: m
        }), /* @__PURE__ */ N("div", {
          className: "p-dialog-header-icons",
          children: [l, a, t]
        })]
      });
    }
    return null;
  }, pe = function() {
    var t = M("p-dialog-content", e.contentClassName), a = d + "_content";
    return /* @__PURE__ */ g("div", {
      id: a,
      ref: p,
      className: t,
      style: e.contentStyle,
      children: e.children
    });
  }, et = function() {
    var t = Y.getJSXElement(e.footer, e);
    return t && /* @__PURE__ */ g("div", {
      ref: te,
      className: "p-dialog-footer",
      children: t
    });
  }, tt = function() {
    return e.resizable ? /* @__PURE__ */ g("span", {
      className: "p-resizable-handle",
      style: {
        zIndex: 90
      },
      onMouseDown: Ae
    }) : null;
  }, nt = function() {
    var t = Y.findDiffKeys(e, j.defaultProps), a = M("p-dialog p-component", e.className, {
      "p-dialog-rtl": e.rtl,
      "p-dialog-maximized": C
    }), l = M("p-dialog-mask", Ye(), {
      "p-component-overlay p-component-overlay-enter": e.modal,
      "p-dialog-visible": h,
      "p-dialog-draggable": e.draggable,
      "p-dialog-resizable": e.resizable
    }, e.maskClassName), m = Qe(), S = pe(), b = et(), o = tt(), f = d + "_header", w = d + "_content", H = {
      enter: e.position === "center" ? 150 : 300,
      exit: e.position === "center" ? 150 : 300
    };
    return /* @__PURE__ */ g("div", {
      ref: x,
      style: e.maskStyle,
      className: l,
      onClick: Le,
      children: /* @__PURE__ */ g(ct, {
        nodeRef: r,
        classNames: "p-dialog",
        timeout: H,
        in: J,
        options: e.transitionOptions,
        unmountOnExit: !0,
        onEnter: je,
        onEntered: Ve,
        onExiting: Be,
        onExited: Fe,
        children: /* @__PURE__ */ N("div", {
          ref: r,
          id: d,
          className: a,
          style: e.style,
          onClick: e.onClick,
          role: "dialog",
          ...t,
          "aria-labelledby": f,
          "aria-describedby": w,
          "aria-modal": e.modal,
          children: [m, S, b, o]
        })
      })
    });
  }, rt = function() {
    var t = nt();
    return /* @__PURE__ */ g(ot, {
      element: t,
      appendTo: e.appendTo,
      visible: !0
    });
  };
  return h && rt();
});
j.displayName = "Dialog";
j.defaultProps = {
  __TYPE: "Dialog",
  appendTo: null,
  ariaCloseIconLabel: null,
  baseZIndex: 0,
  blockScroll: !1,
  breakpoints: null,
  className: null,
  closable: !0,
  closeOnEscape: !0,
  contentClassName: null,
  contentStyle: null,
  dismissableMask: !1,
  draggable: !0,
  focusOnShow: !0,
  footer: null,
  header: null,
  headerClassName: null,
  headerStyle: null,
  icons: null,
  id: null,
  keepInViewport: !0,
  maskClassName: null,
  maskStyle: null,
  maximizable: !1,
  maximized: !1,
  minX: 0,
  minY: 0,
  modal: !0,
  onClick: null,
  onDrag: null,
  onDragEnd: null,
  onDragStart: null,
  onHide: null,
  onMaskClick: null,
  onMaximize: null,
  onResize: null,
  onResizeEnd: null,
  onResizeStart: null,
  onShow: null,
  position: "center",
  resizable: !0,
  rtl: !1,
  showHeader: !0,
  style: null,
  transitionOptions: null,
  visible: !1
};
const se = ({
  className: e,
  header: c,
  children: i,
  footer: v,
  visible: d,
  onOk: z,
  onCancel: y,
  closable: E = !1,
  ...h
}) => (at(() => {
  if (d && (z || y)) {
    const _ = (P) => {
      typeof z == "function" && P.key === "Enter" && z(), typeof y == "function" && P.key === "Escape" && y();
    };
    return document.addEventListener("keydown", _, !1), () => document.removeEventListener("keydown", _, !1);
  }
}, [d, z, y]), /* @__PURE__ */ g(j, {
  className: `bw-dialog${e ? ` ${e}` : ""}`,
  header: c,
  showHeader: !!c,
  children: i,
  footer: v,
  visible: d,
  onHide: y,
  blockScroll: !0,
  focusOnShow: !1,
  closable: E,
  ...h
})), Et = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Dialog: se,
  default: se
}, Symbol.toStringTag, { value: "Module" }));
export {
  se as Dialog,
  Et as index
};
